<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <a-select
          allowClear
          show-search
          v-decorator="['version', { rules: [{ required: true, message: '版本号不能为空' }] }]"
          :dropdown-match-select-width="false"
          slot="version"
          @change="changeVersion"
          option-filter-prop="children"
          option-label-prop="label">
          <a-select-option v-for="(item) in versionSelectList" :key="item.realValue" :value="item.realValue" :label="item.label">
            {{ item.label }}
          </a-select-option>
        </a-select>
        <global-select
          ref="organizationCodeListRef"
          slot="organizationCodeList"
          :value.sync="queryParams.organizationCodeList"
          selectType="selectMultipleSearch"
          requestApi="/scp/scpCallManager/orgComboBox"
          :setParams="{ version: queryParams.version }"
          :selectItem="{ value: 'realValue', label: 'label' }"
          searchParam="orgCode"
        />
        <global-select
          slot="statusList"
          :value.sync="queryParams.statusList"
          selectType="selectMultiple"
          :selectData="statusList"
          :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
        />
        <a-input slot="wipEntityName" v-model="queryParams.wipEntityName" allowClear />
<!--        <global-select
          slot="wipEntityName"
          :value.sync="queryParams.wipEntityNameList"
          selectType="selectMultipleSearch"
          requestApi="/mes/mesDiscreteJobs/allWipEntityName"
          :selectItem="{ value: 'realValue', label: 'label' }"
          searchParam="wipEntityName"
        />-->
        <!--叫料标识-->
        <a-select slot="callFlag" v-model="queryParams.callFlag" allowClear>
          <a-select-option value="Y">是</a-select-option>
          <a-select-option value="N">否</a-select-option>
        </a-select>
        <!--生成工单备注-->
        <a-select slot="bomRemark" v-model="queryParams.bomRemark" allowClear>
          <a-select-option v-for="item in bomRemarkList" :key="item.realValue">{{ item.realValue }}</a-select-option>
        </a-select>
        <global-select
          ref="firstLevelCodeRef"
          slot="firstLevelCodeList"
          :value.sync="queryParams.firstLevelCodeList"
          selectType="selectMultipleFilter"
          requestApi="/scp/scpCallManager/firstLevelCodeComboBox"
          :selectItem="{ value: 'realValue', label: 'label' }"
          searchParam="firstLevelName"
        />
      </ls-search-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button @click="onUpdateCallDemand" type="primary" :loading="loading">更新叫料数据</a-button>
      <a-button @click="onCreateMaterial('hardware')" type="primary" :loading="loading" :disabled="selectedRows.length<1">非配色叫料</a-button>
      <a-button @click="onCreateMaterial('fabric')" type="primary" :loading="loading" :disabled="selectedRows.length<1">配色叫料</a-button>
      <a-button @click="onBatchUpdate" type="primary" :loading="loading" :disabled="selectedRows.length<1">批量修改叫料标识</a-button>
      <a-button @click="onExport" :loading="loading">导出</a-button>
      <download-modal :apiFun="apiExportCallManager" ref="download" />
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <ls-api-table
          class="workOrderMaterialTableCss"
          ref="workOrderMaterialTable"
          :columns="columns"
          :tableProps="tableProps"
          :selectedRows.sync="selectedRows"
          :multi-select="true"
          rowKey="id"
          @selectedRowChange="selectedRowChange"
          :scroll="{ fixScreen: true, x: 1400, extraHeight: 100 }"
          @change="handleTableChange"
        >
          <template #lastSupplyDateTitle>
            <span>实际供应时间</span>
            <a-icon class="action-icon" @click.stop="onEditDate" type="edit" title="编辑"/>
          </template>
          <!--工厂库存-->
          <template slot="factoryTempQty" slot-scope="{ record }">
            <a @click="onFactoryInventory(record)" href="javascript:;">{{ record.factoryTempQty }}</a>
          </template>
          <!--工单日志-->
          <template slot="wipLog" slot-scope="{ record }">
            <a-popover placement="topLeft" :overlayStyle="{ width: '500px' }" v-if="record.wipLog" :destroyTooltipOnHide="true">
              <template slot="content" class="abc-css">
                <div v-for="(item, index) in record.wipLog.split('<br/>')" class="popover-item" :key="'logIndex'+index">
                  <div class="item">{{ item }}</div>
                </div>
              </template>
              <a href="javascript:;">日志</a>
            </a-popover>
          </template>
          <template slot="footer">
            <StickyFixedSummary
              ref="summaryRef"
              :footerTableColumns="footerTableColumns"
              :columns="columns"
              :dateFiledList="dateFiledList" />
          </template>
        </ls-api-table>
        <!--批量修改叫料-->
        <batch-edit-modal ref="batchEditModalRef1" @successFun="refresh" />
        <create-order-material ref="createOrderMaterialRef" @successFun="onSearch" />
        <factory-inventory-modal ref="factoryInventoryModalRef" />
        <batch-edit-date-modal ref="batchEditDateModalRef" @successFun="refresh" />
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { generateLsTableResData } from '@/utils/util.js'
import batchEditModal from './components/batch-edit-modal'
import batchEditDateModal from '@/views/scp/factoryCallMaterial/workOrderMaterial/components/batch-edit-date-modal'
import createOrderMaterial from './components/create-order-material'
import factoryInventoryModal from './components/factory-inventory-modal'
import { mapState } from 'vuex'
import cacheSearch from '@/mixins/cacheSearch'
import {
  apiScpCallManagerList,
  apiUpdateCallDemand,
  apiExportCallManager,
  apiBomRemarkComboBox,
  apiSumCallManagerQty
} from '@/api/scp/work-order-material/work-order-material'
import cloneDeep from 'lodash.clonedeep'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import { apiGetVersionSelectList } from '@/api/scp/factoryCallMaterial/materialGrossDemandReport'
import cacheRequest from '@/mixins/cacheRequest'
import StickyFixedSummary from '@/components/StickyFixedSummary'

export default {
  name: 'WorkOrderMaterial',
  components: {
    batchEditModal,
    createOrderMaterial,
    factoryInventoryModal,
    DownloadModal,
    batchEditDateModal,
    StickyFixedSummary
  },
  mixins: [cacheSearch, cacheRequest],
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    }),
    footerTableColumns () {
      return [
        { title: '勾选', align: 'center', width: 60, stickyFixed: 'left' },
        ...this.columns
      ]
    }
  },
  data () {
    return {
      apiExportCallManager,
      versionSelectList: [], // 版本号下拉选择框
      bomRemarkList: [], // bom工单备注
      statusList: [], // 工单状态
      formList: [
        { label: '版本号', decorator: ['version'], type: 'version' },
        { label: '加工厂', decorator: ['organizationCodeList'], type: 'organizationCodeList' },
        { label: '工单号', decorator: ['wipEntityName'], type: 'wipEntityName' },
        { label: '工单状态', decorator: ['statusName'], type: 'statusList' },
        {
          label: '实际供应时间',
          type: 'range',
          decorator: ['lastSupplyDate'],
          disposeFormat: {
            lastSupplyDateFrom: (change) => {
              return change[0].format('yyyy-MM-DD 00:00:00')
            },
            lastSupplyDateTo: (change) => {
              return change[1].format('yyyy-MM-DD 23:59:59')
            }
          }
        },
        { label: '零部件-物料编码', decorator: ['componentsCode'], type: 'input' },
        { label: '零部件-物料名称', decorator: ['componentsName'], type: 'input' },
        { label: '零部件-规格描述', decorator: ['componentsDesc'], type: 'input' },
        { label: '原材料-物料编码', decorator: ['rawMaterialCode'], type: 'input' },
        { label: '叫料标识', decorator: ['callFlag'], type: 'callFlag' },
        { label: '生成工单备注', decorator: ['bomRemark'], type: 'bomRemark' },
        { label: '一级分类', decorator: ['firstLevelCodeList'], type: 'firstLevelCodeList' }
      ],
      loading: false,
      // 表格配置1
      tableProps: {
        requestApi: generateLsTableResData(apiScpCallManagerList, true),
        pageCurrent: true
      },
      // 查询参数
      queryParams: {
        wipEntityName: undefined,
        wipEntityNameList: undefined,
        organizationCodeList: [],
        lastSupplyDate: undefined,
        lastSupplyDateTo: undefined,
        lastSupplyDateFrom: undefined,
        statusList: [],
        componentsCode: undefined,
        componentsName: undefined,
        componentsDesc: undefined,
        rawMaterialCode: undefined,
        callFlag: undefined,
        bomRemark: undefined,
        version: undefined
      },
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      // 表格字段
      columns: [
        { title: '加工厂', dataIndex: 'organizationName', width: 100, align: 'center', stickyFixed: 'left' },
        { title: '工单号', dataIndex: 'wipEntityName', width: 100, align: 'center', stickyFixed: 'left' },
        { title: '工单状态', dataIndex: 'status', width: 75, ellipsis: true, align: 'center', stickyFixed: 'left' },
        { title: '创建时间', dataIndex: 'createTime', width: 100, align: 'center', stickyFixed: 'left' },
        { title: '下推时间', dataIndex: 'releaseDate', width: 100, sorter: true, align: 'center', ellipsis: true, stickyFixed: 'left' },
        { title: '计划完成时间', dataIndex: 'scheduledCompletionDate', sorter: true, width: 110, align: 'center', stickyFixed: 'left' },
        { title: '零部件-物料编码', dataIndex: 'componentsCode', width: 100, align: 'center', stickyFixed: 'left' },
        { title: '零部件-物料名称', dataIndex: 'componentsName', width: 100, align: 'center', ellipsis: true, stickyFixed: 'left' },
        { title: '零部件-规格描述', dataIndex: 'componentsDesc', width: 120, align: 'center', ellipsis: true, stickyFixed: 'left' },
        { title: '零部件套数', dataIndex: 'componentsQty', width: 90, align: 'center' },
        // { title: 'MRP版本号', dataIndex: 'planVersion', width: 90, align: 'center' },
        { title: '叫料标识', dataIndex: 'callFlag', width: 75, align: 'center' },
        { title: '原材料-物料编码', dataIndex: 'rawMaterialCode', width: 100, align: 'center' },
        { title: '原材料-物料名称', dataIndex: 'rawMaterialName', width: 140, ellipsis: true, align: 'center' },
        { title: '原材料-规格描述', dataIndex: 'rawMaterialDesc', width: 180, align: 'center', ellipsis: true },
        { title: '单位', dataIndex: 'uom', width: 70, align: 'center' },
        { title: 'BOM需求数量', dataIndex: 'bomDemandQty', width: 75, align: 'center' },
        { title: '已叫料', dataIndex: 'callQty', width: 70, align: 'center' },
        { title: '未叫料', dataIndex: 'unCallQty', width: 70, align: 'center' },
        { title: 'VMI库存数量', dataIndex: 'vmiInventoryQty', width: 75, align: 'center' },
        { title: '工厂暂存总量', dataIndex: 'factoryTempQty', width: 75, align: 'center', scopedSlots: { customRender: 'factoryTempQty' } },
        {
          // title: '实际供应时间',
          dataIndex: 'lastSupplyDate',
          width: 110,
          align: 'center',
          sorter: true,
          scopedSlots: { title: "lastSupplyDateTitle" }
        },
        { title: '建议供应时间', dataIndex: 'suggestedSupplyDate', width: 110, align: 'center' },
        { title: '生成工单备注', dataIndex: 'bomRemark', width: 100, ellipsis: true, align: 'center' },
        { title: '工单日志', dataIndex: 'wipLog', width: 100, ellipsis: true, align: 'center', scopedSlots: { customRender: 'wipLog' } },
        { title: '版本号', dataIndex: 'version', width: 95, align: 'center' },
        { title: '创建人', dataIndex: 'createName', width: 70, align: 'center' },
        { title: '上一个版本号', dataIndex: 'lastVersion', width: 95, align: 'center' },
        { title: '一级分类', dataIndex: 'firstLevelName', width: 95, align: 'center' }
      ],
      dateFiledList: [
        { title: 'BOM需求数量', dataIndex: 'bomDemandQty', width: 75, align: 'center' },
        { title: '已叫料', dataIndex: 'callQty', width: 70, align: 'center' },
        { title: '未叫料', dataIndex: 'unCallQty', width: 70, align: 'center' }
      ]
    }
  },
  created () {
    this.cacheLookupRequest('MES_JOB_STATUS', { lookupType: 'MES_JOB_STATUS', current: 1, pageSize: 999 }, 'statusList')
    this.getBomRemarkList();
    // 处理缓存逻辑
    this.getHistoryCache('refSearchForm', '', { lastSupplyDate: ['lastSupplyDateTo', 'lastSupplyDateFrom'] })
  },
  mounted () {
    this.$nextTick(() => {
      if (this.$refs?.workOrderMaterialTable) this.$refs.summaryRef.initSet(this.$refs.workOrderMaterialTable)
    })
    this.loading = false;
    this.initGetVersion();
    // this.onSearch()
  },
  methods: {
    // 批量编辑日期
    onEditDate() {
      if(this.selectedRows?.length === 0) {
        return this.$message.warning("请勾选单据进行修改")
      }
      this.$refs.batchEditDateModalRef.show(this.selectedRows)
    },
    // 兼容处理excel复制工单号
    onChangeWipEntity() {
      const wipEntityList = []
      if (this.queryParams?.wipEntityName) {
        const list = this.queryParams.wipEntityName.split(' ')
        list.forEach((v, i) => {
          list[i] = v.replace(/[\n\r\s\W_]+/g, '') // 去掉excel可能存在的特殊字符
          if (list[i]) { wipEntityList.push(list[i]) }
        })
      }
      this.queryParams.wipEntityNameList = wipEntityList
    },
    // 修改版本
    changeVersion(val) {
      this.queryParams.version = val
      this.queryParams.organizationCodeList = []
      this.$refs.organizationCodeListRef.handleSearch('')
    },
    // 初始化获取版本数据
    initGetVersion() {
      apiGetVersionSelectList({ pageNum: 1, pageSize: 999 }).then(res => {
        this.versionSelectList = res?.rows?.filter(item => item !== null) || []
        if (this.versionSelectList.length > 0) {
          if (!this.queryParams?.version) {
            this.$set(this.queryParams, 'version', this.versionSelectList[0].realValue)
            this.$refs.refSearchForm.form.setFieldsValue({
              version: this.versionSelectList[0].realValue
            })
          }
        }
        this.onSearch()
      })
    },
    // 获取工单备注数据
    getBomRemarkList() {
      this.bomRemarkList = [];
      apiBomRemarkComboBox({}).then(res => {
        if (res?.length > 0) {
          this.bomRemarkList = res
        }
      })
    },
    // table排序等
    handleTableChange (pagination, filters, sorter, { currentDataSource }) {
      let obj = {}
      const params = this.$refs.workOrderMaterialTable.searchParams
      if(sorter?.order && sorter?.columnKey) {
        obj = {
          orderColumn: sorter.columnKey,
          sortFlag: sorter.order === "ascend" ? 'asc' : 'desc'
        }
        this.$refs.workOrderMaterialTable.searchParams = cloneDeep({ ...params, ...obj });
      } else {
        if (params?.orderColumn) {
          delete params.orderColumn
          delete params.sortFlag
          this.$refs.workOrderMaterialTable.searchParams = params
        }
      }
    },
    // 打开工厂库存弹窗
    onFactoryInventory(record) {
      this.$refs.factoryInventoryModalRef.show(record)
    },
    // 行选中
    selectedRowChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    // 五金\皮布叫料
    onCreateMaterial(type) {
      if (this.selectedRows?.length < 1) {
        this.$message.warning('请勾选数据')
        return false
      }
      const params = this.$refs.workOrderMaterialTable.searchParams
      const totalData = this.$refs?.workOrderMaterialTable?.myDataSource || []
      this.$refs.createOrderMaterialRef.show(this.selectedRows, type, this.selectedRows.length === totalData.length, params)
    },
    // 导出工单叫料
    onExport() {
      const params = this.$refs.workOrderMaterialTable.searchParams
      this.$refs.download.openModal(params)
    },
    // 批量修改叫料标识
    onBatchUpdate() {
      if (this.selectedRows?.length < 1) {
        this.$message.warning('请勾选数据')
        return false
      }
      this.$refs.batchEditModalRef1.show(this.selectedRows)
    },
    // 更新叫料需求
    onUpdateCallDemand() {
      const self = this;
      self.loading = true;
      apiUpdateCallDemand({}).then((response) => {
        self.loading = false;
        if (response.code === 200) {
          self.$message.success('更新成功')
          self.refresh()
        } else {
          self.$message.error(response.msg)
        }
      }).catch(() => {
        self.loading = false
      })
    },
    refresh () {
      this.onSearch({ ...this.$refs.refSearchForm?.getSearchValue() })
    },
    // 表单搜索
    onSearch (value = {}) {
      this.onChangeWipEntity(); // 判断是否要处理工单号
      const params = Object.assign({}, this.queryParams, value)
      delete params.searchFormLabel
      if (!params?.version) {
        this.$message.warning('请先选择版本号')
        return
      }
      this.setSearchCache(params) // 设置缓存
      const historyParams = this.$refs.workOrderMaterialTable.searchParams
      if (historyParams?.orderColumn) { params.orderColumn = historyParams.orderColumn }
      if (historyParams?.sortFlag) { params.sortFlag = historyParams.sortFlag }
      this.$refs.workOrderMaterialTable.searchParams = cloneDeep({ ...params });
      if (this.$refs?.summaryRef) this.$refs.summaryRef.summaryFromApi({ ...params }, apiSumCallManagerQty)
      this.$refs.workOrderMaterialTable.getData();
    },
    // 重置按钮操作
    resetQuery () {
      this.queryParams = {
        wipEntityName: undefined,
        wipEntityNameList: undefined,
        organizationCodeList: [],
        lastSupplyDate: undefined,
        lastSupplyDateTo: undefined,
        lastSupplyDateFrom: undefined,
        statusList: [],
        componentsCode: undefined,
        componentsName: undefined,
        componentsDesc: undefined,
        rawMaterialCode: undefined,
        bomRemark: undefined,
        callFlag: undefined,
        version: undefined
      }
      this.$refs.organizationCodeListRef.handleSearch('')
      // this.onSearch()
    }
  }
}
</script>

<style scoped lang="less">
@import '../../../../components/StickyFixedSummary/styles/footerTable.less';
.workOrderMaterialTableCss{
  /deep/ .ant-table-tbody tr td {
    padding: 8px 8px;
  }
  /deep/ .ant-table-thead > tr > th {
    padding: 12px 8px;
  }
  /deep/ .sticky-columns{
    position: sticky !important;
  }
  /deep/ .ant-table-column-sort{
    background: #fff;
  }
}
.popover-item{
  display: inline-block;
  width: 480px;
  .item{
    padding-bottom: 5px;
  }
}
.ml10{
  margin-left: 10px;
}.ellipsis{
   display:block;
   width:150px;
   text-overflow: ellipsis;
   white-space: nowrap;
   overflow: hidden;
 }

.action-icon{
  cursor: pointer;
  font-size: 14px;
  color: #0486fe;
}

</style>
